// extracted by mini-css-extract-plugin
module.exports = {"backButton":"Back_backButton__BmJs6","onlyMobile":"Back_onlyMobile__2IJ7S"};